import { isUnnamed, peopleCount } from '@horof/shared';
import { Tag } from 'antd';

/**
 * The people a member pays shart for (arqam doc 45), to read. They are
 * added, named and removed on the desk (docs/changes/41).
 */
export function ShartPeople({
  people,
}: {
  people: { id: string; name: string }[];
}) {
  return (
    <section className="card">
      <div className="bill-head">
        <div className="field-label">الشرط (خدمات الإمام)</div>
        <Tag>{people.length ? peopleCount(people.length) : 'لا أحد'}</Tag>
      </div>
      <ul className="plain-list shart-list">
        {people.map((p) => (
          <li
            key={p.id}
            className={`shart-row${isUnnamed(p.name) ? ' is-unnamed' : ''}`}
          >
            <span className="shart-name">
              {p.name}
              {isUnnamed(p.name) && (
                <Tag color="orange" className="shart-tag">
                  بدون اسم
                </Tag>
              )}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
